import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import UserSearchVM from "./UserSearchVM";
import { Router } from 'aurelia-router';
import MemberData01 from "../../../Core/Scripts/AppServiceContract/MemberData01";
import MemberUpdateRequest from "../../../Core/Scripts/AppServiceContract/MemberUpdateRequest";

export default class UserEditorVM extends EditorVMBase {

    router: Router;

    Id: string;
    GroupUID: string;
    UserUID: string;
    UserName: string;
    UserCode: string;

    constructor() {
        super();
        this.router = Container.instance.get(Router);
    }

    LoadOriginalSource(originalSource: MemberData01) {
        this.Id = originalSource.UserUID
        this.GroupUID = originalSource.GroupUID
        this.UserUID = originalSource.UserUID
        this.UserName = originalSource.Name
        this.UserCode = originalSource.UserCode;
    }

    SaveOriginalSource(originalSource: MemberData01) {
        originalSource.UserUID = this.Id;
        originalSource.GroupUID = this.GroupUID;
        originalSource.UserUID = this.UserUID;
        originalSource.Name = this.UserName;
        originalSource.UserCode = this.UserCode;
    }

    Remove(searchVM: UserSearchVM, removeCallback: () => void) {
        var self = this;

        var req = new MemberUpdateRequest();

        req.GroupUID = self.GroupUID;
        req.UserUID = self.UserUID;

        //ManageUserGroupService.Service.RemoveMember(null, req)
        //    .done((result) => {
        //        FsUtility.AlertModal("The item has been updated successfully", 2, 1);
        //        if (removeCallback != null)
        //            removeCallback();
        //    }).fail((error) => {
        //        if (error.status != 401) {
        //            FsUtility.CommonErrorHandler(error);
        //        }
        //    });
    }
}
